import { createIcon } from './createIcon'

export const TableIcon = createIcon({
  displayName: 'TableIcon',
  viewBox: '4 4 12 12',
  path: [
    <path
      d="M5.33333 16C4.96667 16 4.65278 15.8694 4.39167 15.6083C4.13056 15.3472 4 15.0333 4 14.6667V5.33333C4 4.96667 4.13056 4.65278 4.39167 4.39167C4.65278 4.13056 4.96667 4 5.33333 4H14.6667C15.0333 4 15.3472 4.13056 15.6083 4.39167C15.8694 4.65278 16 4.96667 16 5.33333V14.6667C16 15.0333 15.8694 15.3472 15.6083 15.6083C15.3472 15.8694 15.0333 16 14.6667 16H5.33333ZM9.33333 12H5.33333V14.6667H9.33333V12ZM10.6667 12V14.6667H14.6667V12H10.6667ZM9.33333 10.6667V8H5.33333V10.6667H9.33333ZM10.6667 10.6667H14.6667V8H10.6667V10.6667ZM5.33333 6.66667H14.6667V5.33333H5.33333V6.66667Z"
      fill="currentColor"
    />,
  ],
})
